
export default class Library {

    static getBoolean(val){
        if( val == "true" || val == "on" || val == "1" || val == true ) 
            return true;
        return false;
    }

    static putBoolean(val){
        if( val ) return "on";
        return "off";
    }

    static getSeconds(datestr){
        if( datestr == null || datestr == "" ){
            var d = new Date();
            return Math.floor(d.getTime()/1000);
        }
        else {
            var year = datestr.substr( 0, 4 );
            var month = datestr.substr( 4, 2 );
            var day = datestr.substr( 6, 2 );
            var o = 0;
            if( datestr.substr( 8,1 ) == "_" ) o = 1;
            var hour = datestr.substr( 8+o, 2 );
            var minute = datestr.substr( 10+o, 2 );
            var cur_date = new Date( Date.UTC(year, month-1, day, hour, minute, 0 ));
            return cur_date.getTime()/1000;
        } 
    }

    static getDate(d, off){
        let date;
        if( off == undefined ) off = 0;
        if( d == null )
            date = new Date();
        else if( typeof d == "string" ){
            date = new Date( Date.UTC(
                        d.substr(0,4),
                        d.substr(4,2)-1,
                        d.substr(6,2),
                        d.substr(8,2),
                        d.substr(10,2), 0, 0 ));
        }
        else if( d instanceof Date == false )
            date = new Date( d * 1000 );

        date = new Date(Math.floor((date.getTime()-off*60000)/
                    60000)*60000);
        let str = "" + date.getUTCFullYear() + 
            String(date.getUTCMonth()+1).padStart(2,'0') +
            String(date.getUTCDate()).padStart(2,'0') + 
            String(date.getUTCHours()).padStart(2,'0') +
            String(date.getUTCMinutes()).padStart(2,'0');
        return str;
    }

    static formatDate(fmt, d){
        if( d == undefined )
            d = new Date();
        else if( d instanceof Date == false )
            d = new Date( d * 1000 );
        if( fmt == "ymd_hn" ) fmt = "%Y%m%d_%H%M";
        if( fmt == "ymdhn" ) fmt = "%Y%m%d%H%M";
        if( fmt == "" ) fmt = "%H%M UTC %d %a %b %Y";
        var month = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
            "Aug", "Sep", "Oct", "Nov", "Dec" ];
        var day = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        var str = fmt.replace( /%([YmdHMShba])/g,
                function(m0,m1){
                if( m1 == "Y" )
                return d.getUTCFullYear();
                if( m1 == "m" )
                return ((d.getUTCMonth()+1)+"").padStart(2,"0");
                if( m1 == "b" || m1 == "h" )
                return month[d.getUTCMonth()];
                if( m1 == "d" )
                return (d.getUTCDate()+"").padStart(2,"0");
                if( m1 == "a" )
                return day[d.getUTCDay()];
                if( m1 == "H" )
                return (d.getUTCHours()+"").padStart(2,"0");
                if( m1 == "M" )
                return (d.getUTCMinutes()+"").padStart(2,"0");
                if( m1 == "S" )
                return (d.getUTCSeconds()+"").padStart(2,"0");
                });
        return str;
    }

    static parseHexColorToArray(hex, op){
        var vals = [0, 0, 0, 1];
        vals[0] = parseInt("0x" + hex.substr(1,2));
        vals[1] = parseInt("0x" + hex.substr(3,2));
        vals[2] = parseInt("0x" + hex.substr(5,2));
        if( op != null ) vals[3] = op;
        return vals;
    }

    static setButtonValue(id, val){
        let elem = document.getElementById( id );
        if( elem == null ) return false;
        return elem.value = val;
    }

    static getCheckbox(id){
        let elem = document.getElementById( id );
        if( elem == null ) return false;
        return elem.checked;
    }
    
    static setCheckbox(id, value){
        let elem = document.getElementById( id );
        if( elem == null ) return;
        if( value == true || value == "true" || value == "on" || value == "1" || value == 1 )
            elem.checked = true;
        else
            elem.checked = false;
    }

    static setSelectOption(id, value){
        let elem = document.getElementById( id );
        if( elem == null ) return null;
        for( let i = 0; i < elem.options.length; i++ ){
            if( elem.options[i].value == value )
                elem.selectedIndex = i;
        }
    }

    static setDivText(id, text){
        let elem = document.getElementById( id );
        if( elem == null ) return;
        elem.innerHTML = text;
    }
}

